import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Button } from "@silvertours/front-shared";
var getExpandedStyles = function(theme) {
    return /*#__PURE__*/ css("margin-block:2rem;min-width:100%;", theme.mq("sm"), "{min-width:100px;}");
};
var getCenteredStyles = function(theme) {
    return /*#__PURE__*/ css("display:flex;/* must be a block-level element for centering */\n  margin-inline:auto;justify-content:center;", theme.mq("sm"), "{left:50%;}");
};
var ExpandButton = /*#__PURE__*/ styled(Button, {
    target: "e1dhaoas0"
})("margin-top:", function(param) {
    var spacingDirection = param.spacingDirection;
    return spacingDirection === "bottom" ? "1.5rem" : "";
}, ";", function(param) {
    var theme = param.theme, isExpanded = param.isExpanded;
    return isExpanded && getExpandedStyles(theme);
}, ";", function(param) {
    var theme = param.theme, isCentered = param.isCentered;
    return isCentered && getCenteredStyles(theme);
}, ";");
export { ExpandButton };
